import React from 'react';
import { useNavigate } from 'react-router-dom';

const AppointmentForkBanner = ({ forkedToId }) => {
  const navigate = useNavigate();

  if (!forkedToId) return null;

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-md p-3 mb-4">
      <div className="flex items-start gap-2">
        <div className="flex-shrink-0 text-blue-500 text-xl">
          ℹ️
        </div>
        <div className="flex-1">
          <p className="text-sm text-blue-900">
            <strong>Creator made a new version</strong> of this appointment. Your session time remains unchanged.
          </p>
          <button
            onClick={() => navigate(`/appointments/${forkedToId}`)}
            className="mt-2 text-sm text-blue-600 hover:text-blue-800 font-medium underline"
          >
            View New Version →
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppointmentForkBanner;
